/**
 * AdSense Configuration
 *
 * Publisher ID lives in three places (all must match):
 *   1. frontend/public/ads.txt
 *   2. frontend/public/index.html (script tag)
 *   3. this file (publisherId)
 *
 * Add your ad slot IDs below once you create them in Google AdSense.
 * Go to: adsense.google.com → Ads → By ad unit → Create ad unit
 * Copy the numeric `data-ad-slot` from the generated snippet into the
 * matching key in `slots` below.
 *
 * To disable a placement temporarily, set its slot to '' or null.
 */

const AD_CONFIG = {
  // Your AdSense Publisher ID — must match ads.txt and index.html script tag
  publisherId: 'ca-pub-8607565924578094',

  // testMode = true renders placeholder boxes (grey stubs) instead of real
  // ads. Keep true until:
  //   1. AdSense account status = "Approved" (adsense.google.com)
  //   2. americandogclub.com is listed under Sites with status "Ready"
  //   3. At least one ad slot below is populated with a real slot ID
  // Flip to false once all three are true.
  testMode: false,

  // Ad Slot IDs — paste each ad unit's `data-ad-slot` numeric ID here.
  // Empty string = ad won't render (placeholder only).
  slots: {
    landingSidebar: '2712377482',   // Display 300x250 rectangle (existing unit from April)
    landingInFeed: '3741503648',    // In-feed fluid unit (existing unit from April, layout key -ho-2+p-6b+ce)
    blogSidebar: '2712377482',      // Reuse Display 300x250 for blog sidebar
    blogInArticle: '3741503648',    // Reuse in-feed for in-article
  },

  // Layout key for the in-feed / fluid slot. Required by Google's fluid ads.
  inFeedLayoutKey: '-ho-2+p-6b+ce',

  // Pages/sections where ads should NOT appear (premium feel + conversion)
  excludedPages: [
    '/checkout',
    '/membership',   // Ad-free so ads don't compete with the upgrade CTA
    '/settings',
    '/admin',
    '/ops',
    '/ngo',          // NGO signup + promo pages stay clean
  ],

  // Check if current page should show ads
  shouldShowAds: (pathname) => {
    return !AD_CONFIG.excludedPages.some(page => pathname.startsWith(page));
  },
};

export default AD_CONFIG;
